import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-tax';

export default function Example() {
  return (
    <>
      <Head>
        <title>Grailed Guide 101: Understanding Grailed Sales Tax</title>
        <meta
          name='description'
          content="Selling on Grailed also comes with tax responsibilities. Here's everything you need to know about how sales tax works and how you can qualify for tax exemptions!"
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-tax' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-tax' />
        <meta property='og:title' content='Grailed Guide 101: Understanding Grailed Sales Tax' />
        <meta
          property='og:description'
          content="Selling on Grailed also comes with tax responsibilities. Here's everything you need to know about how sales tax works and how you can qualify for tax exemptions!"
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-08-05T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-08-05T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
